import { Gallerie } from "@/src/data/types";
import { useEffect, useState } from "react";
import { getAllGalleries } from "../../API/Mediatheque/Gallerie/gallerieService";
import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
} from "../../components/ui/carousel";
import img from "../../images/installation_paysage.jpg";
import "../../style/carouselPerView.css";
const MediathequePhoto = () => {
  const [hoveredIndex, setHoveredIndex] = useState<number | null>(null);
  const uploadUrl = process.env.REACT_APP_FILE_UPLOAD;

  const [galleries, setGalleries] = useState<Gallerie[]>([]);
  const fetchData = async () => {
    const response = await getAllGalleries();
    setGalleries(response?.galleries);
  };
  useEffect(() => {
    fetchData();
  }, []);

  return (
    <div className=" mb-52">
      <div className="">
        <section
          className="p-10 text-center lg:p-32 bg-black/70 bg-blend-overlay "
          style={{
            backgroundImage: `url(${img})`,
            backgroundSize: "cover",
            backgroundRepeat: "no-repeat",
            backgroundPosition: "center",
          }}
        >
          <h1 className="text-2xl font-bold text-center text-white md:text-4xl lg:text-7xl">
            {"Médiathèque  "}
          </h1>

          <div className="flex justify-center mt-3">
            <p className="w-full text-white ">
              {"Toutes nos documentations à votre disposition"}
            </p>
          </div>
        </section>
      </div>

      <div>
        <h1 className="container mx-auto mt-20 mb-20 text-4xl font-bold text-center text-black uppercase md:px-40 sm:px-40">
          photos
        </h1>

        <div className="flex justify-center w-full mt-2 space-x-3 ">
          <Carousel
            opts={{ align: "start", loop: true }}
            className="w-full "
            slides={galleries.map((slide) => slide.image)}
          >
            <div className="flex justify-end mr-14">
              <CarouselNext className="relative text-black hover:bg-primary bg-neutral-100 hover:text-white" />
              <CarouselPrevious className="relative text-black hover:bg-primary bg-neutral-100 hover:text-white" />
            </div>
            <CarouselContent>
              {galleries.map((slide, index) => (
                <CarouselItem
                  key={slide.id}
                  className="basis-auto"
                  onMouseEnter={() => setHoveredIndex(index)}
                  onMouseLeave={() => setHoveredIndex(null)}
                >
                  <img
                    //src={slide.image}
                    src={`${uploadUrl}/medias/pictures/${slide.image}`}
                    alt={`Slide ${slide.id}`}
                    className={`transform w-[550px] h-[450px] ${
                      hoveredIndex === index ? "scale-110 z-30" : "z-0"
                    } transition-all duration-300 ${
                      hoveredIndex === null || hoveredIndex === index
                        ? "opacity-100"
                        : "opacity-10"
                    }`}
                  />
                  <p className="text-sm">{slide.title}</p>
                </CarouselItem>
              ))}
            </CarouselContent>
          </Carousel>
        </div>
      </div>
    </div>
  );
};

export default MediathequePhoto;
